import React, { memo } from "react";

import { RecommendationsCarousel } from "../RecommendationsCarousel";
import { NoSearchResultsTopQueries } from "../../molecules";

// Styles
import styles from "./NoSearchResults.module.scss";

interface NoSearchResultsProps {
  searchTerm: string;
  searchResultType: string;
  isFrenchLocale: boolean;
  queryRecommendation: QueryRecommendation;
  productRecommendation: ProdRecommendation;
  onClickTopQuery: (searchTerm: string) => void;
}

/**
 * @NoSearchResults for displaying search results when no matches are found.
 * @param {NoSearchResultsProps} props - The props for the NoSearchResults component.
 * @returns {JSX.Element} JSX element representing the NoSearchResults UI.
 */
export const NoSearchResults: React.FC<NoSearchResultsProps> = memo(
  ({
    searchTerm,
    searchResultType,
    isFrenchLocale,
    queryRecommendation,
    productRecommendation,
    onClickTopQuery,
  }): JSX.Element => {
    const showCarousel =
      !isFrenchLocale && productRecommendation?.records?.length;

    return (
      <section className={`${styles.noSearchResultsWrapper} OneLinkTx`}>
        <NoSearchResultsTopQueries
          topQueries={queryRecommendation?.records}
          isFrenchLocale={isFrenchLocale}
          searchTerm={searchTerm}
          onClick={onClickTopQuery}
        />

        {/* Product Recommendations Carousel */}
        {showCarousel && (
          <RecommendationsCarousel
            products={productRecommendation?.records}
            productsType={productRecommendation?.type}
            searchResultType={searchResultType}
          />
        )}
      </section>
    );
  }
);

NoSearchResults.displayName = "NoSearchResults";
